<template>
	<div class="c-pricing-table">
		<div class="c-pricing-table__selector" v-if="!monthlyOnly">
			<a
				href="#"
				:class="[{ active: frequency === 'monthly' }]"
				@click.prevent="changeFrequency('monthly')"
			>
				Monthly pricing
			</a>
			<a
				href="#"
				:class="[{ active: frequency === 'annual' }]"
				@click.prevent="changeFrequency('annual')"
			>
				Annual pricing
			</a>
		</div>
		<div class="c-pricing-table__body">
			<div class="c-pricing-table__card" v-for="(card, i) in cards" :key="i">
				<div class="c-pricing-table__card__header">
					<h5>{{ card.name }}</h5>
					<h3 v-if="offerPercent">
						${{ getOfferCardPrice(card) }} <span> per month </span>
					</h3>
					<h3 v-else>${{ getCardPrice(card) }} <span> per month </span></h3>
					<p v-if="offerPercent" class="offer-price-detail">
						50% off your first 3 months. Then ${{ getCardPrice(card) }}/month.
					</p>
					<article class="article-text" v-if="false">
						{{ card.description }}
					</article>
					<p v-if="frequency === 'annual'" class="annual-discount">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							fill="none"
						>
							<path
								d="M12 7.5V6.5M12 16.5V17.5M14.1655 9C13.7333 8.4022 12.9254 8 12 8H11.7222C10.4949 8 9.5 8.79594 9.5 9.77778V9.8541C9.5 10.5564 9.99598 11.1984 10.7812 11.5125L13.2188 12.4875C14.004 12.8016 14.5 13.4436 14.5 14.1459C14.5 15.1699 13.4624 16 12.1824 16H12C11.0746 16 10.2667 15.5978 9.83446 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
						Save ${{ getDiscount(card) }} on annual billing
					</p>
					<a
						v-if="!showFeatureLists"
						class="btn btn-primary"
						href="https://app.swipekit.app"
					>
						Start free trial
					</a>
				</div>
				<!--
				<div v-if="showFeatureLists" class="c-pricing-table__card__body">
					<h5>Features</h5>
					<ul>
						<li class="list-title">
							<strong>Brand Tracker: {{ card.trackerLimit }}</strong>
							<strong>Seats: {{ card.seats }}</strong>
						</li>
					</ul>
					<ul v-for="(category, j) in categories" :key="j">
						<li class="list-title">
							<strong>{{ category.name }}</strong>
						</li>

						<li v-for="(feature, k) in category.features" :key="k">
							<svg
								v-if="card.features.includes(feature)"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M7 13L10 16L17 8"
									stroke="currentColor"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
							<svg
								v-else
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M8 8L16 16M16 8L8 16"
									stroke="red"
									stroke-width="2"
									stroke-linecap="round"
								/>
							</svg>

							<span>
								{{ feature }}
							</span>
						</li>
					</ul>
				</div>
				-->

				<div class="c-pricing-table__card__summary">
					<div
						v-for="(row, rowIndex) in summaryRows"
						:key="'summary-row-' + rowIndex"
						class="c-pricing-table__summary-item"
					>
						<span
							class="c-pricing-table__summary-label c-pricing-table__summary-label--with-icon"
						>
							<span
								class="c-pricing-table__summary-icon"
								aria-hidden="true"
								v-html="row.icon"
							></span>
							<span>{{ row.label }}</span>
						</span>
						<strong class="c-pricing-table__summary-value">{{
							getSummaryValue(row, card)
						}}</strong>
					</div>
				</div>
				<div v-if="footer" class="c-pricing-table__card__footer">
					<small class="bold" v-if="frequency === 'annual' && !isPaid">
						You will be charged ${{ getCardPrice(card) * 12 }} upfront on annual
						billing.
					</small>
					<small> All prices are in USD. </small>
					<small>
						By upgrading, you agree to
						<a href="https://swipekit.app/terms" target="_blank"
							>Swipekit's terms.</a
						>
					</small>

					<button
						v-if="!isPaid"
						@click="onUpgrade(card)"
						type="button"
						:class="[
							'btn btn-primary btn-box',
							{ disabled: processing === true },
						]"
					>
						<div v-if="processingPlan === card.name" class="c-spinner"></div>
						<span>Subscribe to {{ card.name }}-{{ frequency }}</span>
					</button>

					<a
						v-if="isPaid && isWorkspaceAdmin && !user.isTrial"
						class="btn btn-box btn-primary"
						:href="`${baseUrl}/user/portal`"
						@click.prevent="gotoBillingPortal"
					>
						<span class="c-spinner" v-if="processing"></span>
						<span> Upgrade/Downgrade subscription </span>
					</a>

					<!-- <button type="button" class="btn">
						<span>
							Current plan
						</span>
					</button> -->
				</div>
			</div>
			<!-- <div class="c-pricing-table__card">
        <div class="c-pricing-table__card__header">
          <h6>Custom plan</h6>
          <h3>Custom plan for larger agencies/brands</h3>
          <span> Min $5000 annual spend gurantee </span>
        </div>
      </div> -->
		</div>
	</div>
</template>

<script>
import api from '@swipekit/lib/api';
import { planCategories, pricingCards, pricingSummaryIcons } from './plan-data';

export default {
	data: function () {
		return {
			processing: false,
			processingPlan: '',
			frequency: this.monthlyOnly ? 'monthly' : 'annual',
			plan: 'Monthly Pro plan',
			categories: planCategories,
		};
	},

	props: {
		prices: {},
		footer: {
			type: Boolean,
			default: true,
		},
		showFeatureLists: {
			type: Boolean,
			default: true,
		},
		monthlyOnly: {
			type: Boolean,
			default: false,
		},
		offerPercent: {
			type: Number,
			default: 0,
		},
	},

	computed: {
		cards: function () {
			return pricingCards;
		},
		summaryRows: function () {
			return [
				{
					label: 'Swipefile',
					icon: pricingSummaryIcons.swipefile,
					value: function () {
						return 'Included';
					},
				},
				{
					label: 'Brand Tracker',
					icon: pricingSummaryIcons.brandTracker,
					value: function (card) {
						return card.trackerLimit;
					},
				},
				{
					label: 'Seats',
					icon: pricingSummaryIcons.seats,
					value: function (card) {
						return card.seats;
					},
				},
				{
					label: 'Multiplayer',
					icon: pricingSummaryIcons.multiplayer,
					value: function () {
						return 'Full access';
					},
				},
				{
					label: 'API Access',
					icon: pricingSummaryIcons.apiAccess,
					value: function () {
						return 'Included';
					},
				},
				{
					label: 'MCP',
					icon: pricingSummaryIcons.mcp,
					value: function () {
						return 'Full access';
					},
				},
				{
					label: 'Whitelabel share links',
					icon: pricingSummaryIcons.whitelabelShareLinks,
					value: function () {
						return 'Included';
					},
				},
			];
		},
		discount: function () {
			let price = this.getPrice();

			return 240;
		},
		currentPrice: function () {
			let price = this.getPrice();

			return price;
		},
		isPaid: function () {
			return this.$store.getters['users/isPaid'];
		},
		baseUrl: function () {
			return this.$store.state.config.baseUrl;
		},
		isWorkspaceAdmin: function () {
			return this.$store.getters['workspaces/isAdmin'];
		},
		user: function () {
			return this.$store.getters['users/user'];
		},
	},

	methods: {
		async gotoBillingPortal() {
			this.processing = true;

			let res = await api.users.portal();

			this.processing = false;

			if (res.portalUrl) {
				window.open(res.portalUrl, '_blank').focus();
			}
		},
		getDiscount: function (card) {
			let frequency = 'monthly';

			let prices = this.prices;

			let price = null;

			for (let i = 0; i < prices.length; i++) {
				let p = prices[i];
				if (p.name.includes(card.name) && p.frequency === frequency) {
					price = p;
					break;
				}
			}

			if (!price) {
				return null;
			}

			return price.price * 4;
		},
		getCardPrice: function (card) {
			let frequency = this.frequency;

			let prices = this.prices;

			let price = null;

			for (let i = 0; i < prices.length; i++) {
				let p = prices[i];
				if (p.name.includes(card.name) && p.frequency === frequency) {
					price = p;
					break;
				}
			}

			if (price) {
				return this.formatPrice(price);
			}

			return null;
		},
		getOfferCardPrice: function (card) {
			const price = this.getPrice(card);
			if (!price) {
				return null;
			}
			return ((price.price * (100 - this.offerPercent)) / 100).toFixed(2);
		},
		formatPrice: function (price, frequency) {
			if (!frequency) {
				frequency = price.frequency;
			}
			let p = price.price;
			if (frequency === 'annual') {
				p = Math.floor(price.price / 12);
			}
			return p;
		},
		getPrice: function (card) {
			let frequency = this.frequency;

			let prices = this.prices;

			let price = null;

			let tag = `${frequency} ${card.name.toLowerCase()}`;

			for (let i = 0; i < prices.length; i++) {
				let p = prices[i];

				if (p.label === tag) {
					price = p;
					break;
				}
			}

			return price;
		},
		getSummaryValue: function (row, card) {
			return row.value(card);
		},
		onUpgrade: function (card) {
			let price = this.getPrice(card);
			if (!price) {
				return false;
			}

			if (this.processing) {
				return false;
			}
			this.processing = true;
			this.processingPlan = card.name;
			this.$emit('event', {
				name: 'checkout_started',
				frequency: this.frequency,
				price: price,
			});
			this.$emit('onUpgrade', {
				plan: price.plan,
				frequency: this.frequency,
				priceId: price.priceId,
			});

			setTimeout(() => {
				this.processingPlan = '';
				this.processing = false;
			}, 4000);
		},
		changeFrequency: function (f) {
			if (this.monthlyOnly) {
				return;
			}
			this.$emit('event', {
				name: 'pricing_frequency_changed',
				frequency: f,
			});
			this.frequency = f;
		},
	},
};
</script>

<style lang="scss">
.c-pricing-table {
	&__selector {
		display: grid;
		grid-template-columns: min-content min-content;
		align-items: center;
		grid-column-gap: var(--margin);
		margin-bottom: var(--spacer);

		> a {
			display: inline-block;
			padding: var(--margin) var(--margin-lg);
			border-radius: 99px;
			background-color: var(--color-bg-3);
			white-space: nowrap;
			user-select: none;
			transition: all var(--transition-time) linear;
			color: var(--color-font);
			font-weight: 500;
			font-feature-settings: 'case' 0, 'dlig' 0, 'frac' 0, 'dnom' 0, 'numr' 0,
				'subs' 0, 'sups' 0, 'tnum', 'zero' 0, 'ss01', 'ss02' 0, 'ss03' 0, 'ss04',
				'ss05' 0, 'ss06' 0, 'ss07' 0, 'ss08' 0, 'cv01' 0, 'cv02' 0, 'cv03' 0,
				'cv04' 0, 'cv05' 0, 'cv06' 0, 'cv07' 0, 'cv08' 0, 'cv09' 0, 'cv10' 0,
				'cv11' 0, 'cv12' 0, 'cv13' 0, 'cpsp' 0, 'c2sc' 0, 'salt' 0, 'aalt' 0,
				'calt', 'ccmp', 'locl', 'kern';

			&.active {
				color: var(--color-primary);
				background-color: hsl(var(--p), 60%, 95%);
				text-decoration: none;
			}

			&:hover,
			&:active {
				color: var(--color-primary);
				background-color: hsl(var(--p), 60%, 95%);
				text-decoration: none;
			}
		}
	}

	&__body {
		display: grid;
		justify-content: center;
		grid-template-columns: 1fr 1fr 1fr;
		grid-column-gap: var(--spacer-sm);
	}

	&__card {
		//width: 400px;
		border-radius: var(--border-radius);
		box-shadow: 0 0 0 1px rgba(17, 24, 28, 0.08),
			0 1px 2px -1px rgba(17, 24, 28, 0.08), 0 2px 4px rgba(17, 24, 28, 0.04);

		ul {
			margin: 0;
			list-style: none;
			padding-left: 0;

			li {
				display: grid;
				grid-template-columns: 24px 1fr;
				margin-bottom: var(--margin);
				font-size: var(--font-size-sm);
				padding: 0;

				&:before {
					content: none;
				}

				&.list-title {
					display: block;

					strong {
						margin-top: var(--margin-lg);
						display: block;
						font-weight: 500;
					}
				}

				// span {
				//   text-decoration: underline;
				//   text-decoration-color: var(--color-success);
				// }

				svg {
					color: var(--color-success);
				}
			}
		}

		h6,
		h5 {
			color: var(--color-primary);
		}

		.article-text {
			opacity: 0.8;
			margin-top: var(--margin);
			margin-bottom: var(--margin);
		}

		h3 {
			font-family: var(--font-family-body);
			margin-bottom: 0;

			> span {
				opacity: 0.75;
				font-size: var(--font-size-sm);
			}
		}

		.offer-price-detail {
			font-size: var(--font-size-xs);
			font-weight: 600;
			color: #d9b400;
			margin-top: var(--margin);
			margin-bottom: 0.25rem;
		}

		&__header {
			padding: 0.5rem;
			padding-bottom: 0;
			//border-bottom: var(--color-bg-4) solid 1px;

			.btn {
				width: 100%;
				margin-top: 0.5rem;
				margin-bottom: 0.25rem;
				border-radius: 0.5rem;
			}

			.annual-discount {
				display: flex;
				align-items: center;
				margin: 0;
				margin-top: var(--margin);
				font-size: var(--font-size-sm);
				font-weight: 600;
				color: #d9b400;

				svg {
					width: 24px;
					height: 24px;
					margin-right: 0.25rem;

					path {
						stroke: currentColor;
					}
				}
			}
		}

		&__body {
			padding: var(--margin-lg);
		}

		&__summary {
			display: grid;
			grid-template-columns: 1fr;
			grid-row-gap: var(--margin-sm);
			padding-top: var(--margin);
		}

		.c-pricing-table__summary-item {
			display: grid;
			grid-template-columns: minmax(0, 1fr) auto;
			align-items: center;
			grid-column-gap: var(--margin);
			padding: 0.5rem;
			border-bottom: 1px solid var(--color-bg-4);
			font-size: var(--font-size-sm);

			&:first-child {
				border-top: 1px solid var(--color-bg-4);
			}

			&:last-child {
				border-bottom: none;
			}

			strong {
				display: block;
				line-height: 1.3;
				font-feature-settings: 'case' 0, 'dlig' 0, 'frac' 0, 'dnom' 0, 'numr' 0,
					'subs' 0, 'sups' 0, 'tnum', 'zero' 0, 'ss01', 'ss02' 0, 'ss03' 0,
					'ss04', 'ss05' 0, 'ss06' 0, 'ss07' 0, 'ss08' 0, 'cv01' 0, 'cv02' 0,
					'cv03' 0, 'cv04' 0, 'cv05' 0, 'cv06' 0, 'cv07' 0, 'cv08' 0, 'cv09' 0,
					'cv10' 0, 'cv11' 0, 'cv12' 0, 'cv13' 0, 'cpsp' 0, 'c2sc' 0, 'salt' 0,
					'aalt' 0, 'calt', 'ccmp', 'locl', 'kern';
			}
		}

		.c-pricing-table__summary-label {
			font-size: var(--font-size-sm);
			color: var(--color-font-light);
			line-height: 1.4;

			&--with-icon {
				display: inline-flex;
				align-items: center;
				gap: 0.5rem;
			}
		}

		.c-pricing-table__summary-value {
			font-size: var(--font-size-sm);
			font-weight: 600;
			text-align: right;
			white-space: nowrap;
		}

		.c-pricing-table__summary-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			color: var(--color-font);
			flex-shrink: 0;

			svg {
				display: block;
				width: 20px;
				height: 20px;
			}
		}

		&__footer {
			padding: var(--margin-lg);
			border-top: var(--color-bg-4) solid 1px;

			pre {
				color: #000;
			}

			small {
				display: block;
				font-size: var(--font-size-xs);
				opacity: 0.75;

				&.bold {
					font-weight: 500;
					opacity: 0.8;
				}
			}

			.btn {
				margin-top: 0.5rem;
				padding: var(--margin-lg);
				width: 100%;

				.c-spinner {
					min-width: 16px;
					margin-right: var(--margin);
					margin-left: 0;
				}
			}
		}
	}

	@media screen and (max-width: 520px) {
		&__card {
			width: 100%;
		}

		&__card__summary {
			grid-template-columns: 1fr;
			grid-row-gap: var(--margin);
		}

		&__body {
			display: block;
		}
	}

	@media screen and (max-width: 768px) {
		&__body {
			grid-template-columns: 1fr;
			grid-row-gap: 0.625rem;
		}
	}
}
</style>
